<template>
	<div class="modal-vue" :id="id" v-if="value">
		<div class="modal-vue-frame animated fadeInDown delay-1s" :class="{md: (size == 'normal'), sm: (size == 'small'), lg: (size == 'large')	}">
			<div class="modal-vue-header" v-if="!!header && header && header != 'false'" >
				<div class="row">
					<div class="col padded">
						<slot name="header" />
					</div>
					<div class="col col-tight padded close" @click="closeModal">
						<i class="fa fa-times"></i>
					</div>
				</div>
			</div>
			<div class="modal-vue-body">
				<slot name="default" />
			</div>
			<div class="modal-vue-footer" v-if="!!footer && footer && footer != 'false'" >
				<slot name="footer">
					<div class="block">
						<button @click="closeModal">Cerrar</button>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	props: {
		size: {
			type: String,
			default: "normal", // normal, small, large
		},
		value: {
			type: [String, Boolean, Number],
		},
		footer: {
			type: [String, Boolean, Number],
			default: true,
		},
		header: {
			type: [String, Boolean, Number],
			default: true,
		},
		id: {
			type: String,
		},
	},
	methods: {
		lockOverscroll() {
            document.body.style.overflow = 'hidden'; // disable scrolling on the body
		},
		unlockOverscroll() {
            document.body.style.overflow = ''; // disable scrolling on the body
		},
		closeModal() {
			this.$emit("input", false);
		},
	},
	watch: {
		value() {
			if (this.value) {
				this.lockOverscroll();
			} else {
				this.unlockOverscroll();
			}
		},
	},
};
</script>

<style lang="scss">
@import '@/sass/utils/_variables';

.text {
	&-white {
		color: var(--white);
	}
	&-primary {
		color: var(--primary);
	}
	&-secondary {
		color: var(--secondary);
	}
	&-danger {
		color: var(--danger);
	}
	&-black {
		color: var(--black);
	}
	&-dimmed {
		color: var(--dimmed);
	}
	&-small {
		font-size: 0.8em;
	}
}

.modal-vue {
	$fixedMargin: 6em;
	z-index: 1001;
	overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.342); 
    backdrop-filter: blur(10px);    
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;


	&-frame {
		z-index: 1;
		margin-top: $fixedMargin;
		margin-bottom: $fixedMargin;
		margin-left: auto;
		margin-right: auto;
		background-color: $primary-dark;
		border-radius: var(--ui-radius);
		box-shadow: var(--ui-shadow);
		&.sm {
			width: 40vw;
			max-width: 420px;
		}
		&.md {
			width: 60vw;
			max-width: 680px;
		}
		&.lg {
			width: 90vw;
			max-width: 1024px;
		}
	}
	.row {
		display: flex;
		flex-flow: row;
		grid: 1em;

		&.row-end {
			align-items: end;
			justify-content: end;
		}

		&.row-centered-v {
			align-items: center;
			justify-content: center;
		}

		& > .col {
			flex: 1;

			&.col-tight {
				flex: 0 1 3em;
			}
		}
	}
	&-header {
		text-align: center;
		border-bottom: var(--ui-border);
		color: $white;
		// font-family: $playRegular;
		font-size: 1.2rem;
		font-weight: 400;
		& > DIV {
			padding: 1.2rem;
		}
		.close {
			cursor: pointer;
			color: $white;
		}
	}
	&-body {
		padding: 1em 0;
	}
	&.no-body {
		.modal-vue-body {
			padding: 0;
		}
	}
	&-footer {
		text-align: right;
		border-top: var(--ui-border);
		padding: calc(var(--ui-font-size) / 1.618);
		padding: 1em;
		border-top: 1px solid $dimmed-highlited;

		button {
			position: relative;
			z-index: 1;
			padding: 0.25em 1.0em;
			border-radius: 0.3em;
			border: none;
			overflow: clip;
			color: #ffffff;
			font-size: 1.1rem;
			text-align: center;
			background: $accent;
			&:hover, &:active {
				background-color: $accent;
			}
			&.dimmed {
				background: #d7d6d6;
				color: #454545;
				&:hover {
					background-color: #d7d6d6;
				}
			}
		}
		
		.button-holder {
			// margin: 0 !important;
			// padding: 0 !important;
		}
	}
}

.swal-button {
	background: $accent;
	color: $black;
	&:not([disabled]):hover,
	&:active {
		background: $accent-dimmed;
	}
	&--cancel {
		background: $dimmed;
		color: $white;
		&:not([disabled]):hover,
		&:active {
			background: $dimmed-highlited;
		}
	}
}
</style>